<template>
    <footer>
        <div class="footWrap">
            <div class="footTop">
                <ul class="footProperty">
                    <li>
                        <i class="iconfont icon-cangweizhenshiyouxiao"></i>
                        <span>{{$t('message.property1')}}</span>
                    </li>
                    <li>
                        <i class="iconfont icon-qian"></i>
                        <span>{{$t('message.property2')}}</span>
                    </li>
                    <li>
                        <i class="iconfont icon-baoxian"></i>
                        <span>{{$t('message.property3')}}</span>
                    </li>
                    <li v-if="$overseasType === false && $i18n.locale === 'zhCHS'">
                        <i class="iconfont icon-xiaoshifuwu"></i>
                        <span>{{$t('message.property4')}}</span>
                    </li>
                </ul>
            </div>
            <div class="footBot">
                <div class="footInfo">
                    <div class="footBotLeft">
                        <p>{{$t('message.aboutUs')}}</p>
                        <p>{{$t('message.aboutUsText1')}}</p>
                        <p>{{$t('message.aboutUsText2')}} <b>{{$t('message.aboutUsText3')}}</b>{{$t('message.aboutUsText4')}}
                        </p>
                        <p style="margin-bottom: 25px;">
                            {{$t('message.aboutUsText5')}}<b>{{$t('message.aboutUsText6')}}</b>{{$t('message.aboutUsText7')}}
                        </p>
                        <p>{{$t('message.friendshipLink')}}</p>
                        <p>
                            <a href="http://weibo.com/jmgjwl"
                               target="_blank"
                               @click="$bigData(bigData,thirdParty,'三脚猫微博'+pathname)">{{$t('message.friendshipLinkText1')}}</a>
                            <a href="http://222.73.210.139/pactl/bill_query.php"
                               target="_blank"
                               @click="$bigData(bigData,thirdParty,'PVG货运站'+pathname)">{{$t('message.friendshipLinkText2')}}</a>
                            <a href="http://www.aircargotracking.net/aircargo-tracking.html"
                               target="_blank"
                               @click="$bigData(bigData,thirdParty,'跟踪查询'+pathname)">{{$t('message.friendshipLinkText3')}}</a>
                        </p>
                        <div style="display: flex">
                            <p><span>Copyright@ 2015 久茂国际物流 All Rights Reserved.&ensp;</span>
                                <a href="http://www.miitbeian.gov.cn/"
                                   target="_blank"
                                   @click="$bigData(bigData,thirdParty,'备案号'+pathname)">沪ICP备05061499号-2</a>
                            </p>
                            <p style="padding-left: 10px">
                                <a href="https://xyt.xcc.cn/getpcInfo?sn=1736929253561192448&language=CN&certType=8&url=*.3j-mall.com"
                                   target="_blank"
                                   style="position: relative;display: inline-block">
                                    <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;">
                                    </div>
                                    <embed src="https://program.xinchacha.com/web/1736929253561192448=*.3j-mall.com.svg"
                                           width="103"
                                           height="38"
                                           type="image/svg+xml"
                                           pluginspage="//www.adobe.com/svg/viewer/install/"/>
                                </a>
                            </p>
                        </div>

                    </div>
                    <div v-if="!$overseasType" class="footBotRight">
                        <div class="footWxDiv">
                            <div class="footWxImg"></div>
                            <p class="footWxTops">{{$t('message.footWxTops')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer',
        data() {
            return {
                // pathname
                pathname: window.location.pathname,
                // bigData
                bigData: 'sjmNewFooter',
                // thirdParty
                thirdParty: '新尾部',
            };
        }
    };
</script>

<style scoped>
    footer {
        position: relative;
        display: block;
        width: 100%;
        min-width: 1245px;
        overflow: hidden;
        background-color: white;
    }

    footer .footWrap {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
    }

    footer .footTop {
        position: relative;
        width: 100%;
        height: 60px;
        background-color: #e2ebf4;
    }

    footer .footProperty {
        display: flex;
        justify-content: space-between;
        width: 1245px;
        padding-top: 7px;
        margin: 0 auto;
    }

    footer .footProperty li {
        flex: 1;
        height: 47px;
        line-height: 47px;
        text-align: center;
        border-right: 1px solid #717071;
    }

    footer .footProperty li:last-child {
        border-right: none;
    }

    footer .footProperty li i.iconfont {
        margin-right: 7px;
        font-size: 37px;
        color: #0071bc;
    }

    footer .footProperty li span {
        font-size: 15px;
        color: #717071;
        vertical-align: super;
    }

    footer .footInfo {
        display: flex;
        width: 1245px;
        margin: 30px auto 0;
        overflow: hidden;
    }

    footer .footBotLeft {
        width: 953px;

        /* float: left; */
        padding-left: 14px;
    }

    footer .footBotLeft p {
        margin-bottom: 10px;
        font-size: 13px;
        color: #808080;
    }

    footer .footBotLeft p b {
        color: #4d4d4d;
    }

    footer .footBotLeft p a {
        margin-right: 4px;
        color: #808080;
    }

    footer .footBotRight {
        position: relative;

        /* float: right; */
        flex: 1;
        border-left: 1px solid #808080;
    }

    footer .footWxDiv {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        margin-right: 40px;
    }

    footer .footWxImg {
        width: 120px;
        height: 120px;
        background-image: url("~@/assets/img/footer/wx_qrcode.jpg");
        background-size: 100%;
        border: 14px solid #e6e6e6;
    }

    footer .footWxTops {
        position: relative;
        width: 237px;
        margin-top: 15px;
        font-size: 14px;
        color: #666;
        text-align: center;
    }
</style>
